import React from 'react';

import Icon from '../Icons';

import { downloadFileBase64 } from '../../utils';
import { useGlobal } from '../../contexts/Global/context';

import * as S from './styles';

function ButtonDownloadBase64({ tooltipIcon, base64Data = null, fileName = null }) {
    const { contrastTheme } = useGlobal();
    return (
        <S.ButtonContainer onClick={() => (base64Data ? downloadFileBase64(base64Data, fileName) : '')}>
            <Icon
                name="file_download"
                tooltip={tooltipIcon}
                size={16}
                color={contrastTheme ? '#FFF333' : '#EC6E0C'}
                style={{ display: 'flex', alignItens: 'center', marginRight: 8 }}
            />
            <S.ButtonLink>Baixar</S.ButtonLink>
        </S.ButtonContainer>
    );
}

export default ButtonDownloadBase64;
